// extracted by mini-css-extract-plugin
export var mySwiper = "textReviewsNew-module--mySwiper--b9133";
export var opacity100 = "textReviewsNew-module--opacity-100--3a14a";
export var studentReview = "textReviewsNew-module--student-review--7a496";
export var student__extra = "textReviewsNew-module--student__extra--86a3d";
export var student__img = "textReviewsNew-module--student__img--22f33";
export var student__info = "textReviewsNew-module--student__info--8e7ee";
export var student__name = "textReviewsNew-module--student__name--75204";
export var student__wrapper = "textReviewsNew-module--student__wrapper--d4b2d";
export var swiperButtonDisabled = "textReviewsNew-module--swiper-button-disabled--56c60";
export var swiperButtonNext = "textReviewsNew-module--swiper-button-next--1f160";
export var swiperButtonPrev = "textReviewsNew-module--swiper-button-prev--53736";
export var textReviewContainer = "textReviewsNew-module--text-review-container--b4763";
export var textReviews = "textReviewsNew-module--text-reviews--ce3af";